import types from './types';

export const getRecaptcha = (payload) => ({
  type: types.SET_RECAPTCHA,
  payload: {
    reCaptchaValue: payload,
  },
});

export const disableRecaptcha = (payload) => ({
  type: types.DISABLE_RECAPTCHA,
  payload: {
    disabled: payload,
  },
});

export const resetCaptcha = (payload) => ({
  type: types.RESET_RECAPTCHA,
  payload: {
    resetRef: payload,
  },
});
